module.exports = __webpack_public_path__ + "img/ic_phone.8ab56cf3.png";